import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import AllWorkplacesCalendar from './AllWorkplacesCalendar';
import { store } from '../../store/store';
import React from 'react';
import { Provider } from 'react-redux';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-all-workplaces-calendar',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<AllWorkplacesCalendar />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
